// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"PostCommentForm-messageBox-SVQbI","poweredBy":"PostCommentForm-poweredBy-T-x75","rteBorderless":"PostCommentForm-rteBorderless-cbWIJ"};